@if (user == null || user.RoleBooleans.IsStudent) {
<div class="flex h-full">
    @if (user == null) {
    <div class="flex h-full">
        <a class="menuItem" routerLink="/instructions">Instructions</a>
    </div>
    }
</div>
}

@if (user != null && user.RoleBooleans.IsStudent === false) {
<div class="flex h-full">
    <app-auto-open-menu>
        <div trigger class="menuItem" (click)="$event.stopPropagation()">Scholarships<mat-icon>arrow_drop_down</mat-icon></div>
        <div content>
            <button mat-menu-item routerLink="/scholarship-list">
                <mat-icon class="float-left w-[35px] min-h-[1px] m-0">list</mat-icon>
                <span class="text-[15px]">Scholarship List</span>
            </button>
            <button mat-menu-item routerLink="/add-scholarship">
                <mat-icon class="float-left w-[35px] min-h-[1px] m-0">add</mat-icon>
                <span class="text-[15px]">Add Scholarship</span>
            </button>
        </div>
    </app-auto-open-menu>
    <app-auto-open-menu>
        <div trigger class="menuItem" (click)="$event.stopPropagation()">Applications<mat-icon>arrow_drop_down</mat-icon></div>
        <div content>
            <button mat-menu-item routerLink="/applicant-list">
                <mat-icon class="float-left w-[35px] min-h-[1px] m-0">list</mat-icon>
                <span class="text-[15px]">Applicant List</span>
            </button>
            <button mat-menu-item routerLink="/submitted/true">
                <mat-icon class="float-left w-[35px] min-h-[1px] m-0">list</mat-icon>
                <span class="text-[15px]">Submitted</span>
            </button>
            <button mat-menu-item routerLink="/submitted/false">
                <mat-icon class="float-left w-[35px] min-h-[1px] m-0">list</mat-icon>
                <span class="text-[15px]">Unsubmitted</span>
            </button>
            <button mat-menu-item routerLink="/scholarship-count">
                <mat-icon class="float-left w-[35px] min-h-[1px] m-0">list</mat-icon>
                <span class="text-[15px]">Scholarship Count</span>
            </button>
        </div>
    </app-auto-open-menu>
    <app-auto-open-menu>
        <div trigger class="menuItem" (click)="$event.stopPropagation()">Tools<mat-icon>arrow_drop_down</mat-icon></div>
        <div content>
            <button mat-menu-item routerLink="/reports">
                <mat-icon class="float-left w-[35px] min-h-[1px] m-0">download</mat-icon>
                <span class="text-[15px]">Reports</span>
            </button>
            <button mat-menu-item routerLink="/roll-forward">
                <mat-icon class="float-left w-[35px] min-h-[1px] m-0">build</mat-icon>
                <span class="text-[15px]">Roll Forward</span>
            </button>
            <button mat-menu-item routerLink="/reopen-application">
                <mat-icon class="float-left w-[35px] min-h-[1px] m-0">build</mat-icon>
                <span class="text-[15px]">Reopen Application</span>
            </button>
            <button mat-menu-item routerLink="/post-processing">
                <mat-icon class="float-left w-[35px] min-h-[1px] m-0">upload</mat-icon>
                <span class="text-[15px]">Post Processing</span>
            </button>
        </div>
    </app-auto-open-menu>
</div>
}